module.exports = __webpack_public_path__ + "img/ss.e6d5e8f7.svg";